import { defineMessages } from 'react-intl'

export default defineMessages({
  frequency: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.frequency',
    defaultMessage: 'Frequency'
  },
  scheduleFor: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.scheduleFor',
    defaultMessage: 'Schedule for'
  },
  oneTime: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.oneTime',
    defaultMessage: 'One time'
  },
  recurring: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.recurring',
    defaultMessage: 'Recurring'
  },
  triggerDateErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.triggerDateErrorMessage',
    defaultMessage: 'Trigger date must be a date in the future'
  },
  repeats: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.repeats',
    defaultMessage: 'Repeats'
  },
  repeat: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.repeat',
    defaultMessage: 'repeat'
  },
  at: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.at',
    defaultMessage: 'at'
  },
  every: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.every',
    defaultMessage: 'every'
  },
  onDay: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.onDay',
    defaultMessage: 'on day'
  },
  onThe: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.onThe',
    defaultMessage: 'on the'
  },
  in: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.in',
    defaultMessage: 'in'
  },
  minutes: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.minutes',
    defaultMessage: 'Minutes'
  },
  hourly: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.hourly',
    defaultMessage: 'Hourly'
  },
  daily: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.daily',
    defaultMessage: 'Daily'
  },
  weekly: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.weekly',
    defaultMessage: 'Weekly'
  },
  monthly: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.monthly',
    defaultMessage: 'Monthly'
  },
  yearly: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.yearly',
    defaultMessage: 'Yearly'
  },
  year: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.year',
    defaultMessage: 'year'
  },
  of: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.of',
    defaultMessage: 'of'
  },
  months: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.months',
    defaultMessage: 'month(s)'
  },
  everyDay: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.everyDay',
    defaultMessage: 'every day'
  },
  everyMinute: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.everyMinute',
    defaultMessage: 'every {time} minute(s)'
  },
  everyHour: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.everyHour',
    defaultMessage: 'every {time} hour(s)'
  },
  monday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Monday',
    defaultMessage: 'Monday'
  },
  tuesday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Tuesday',
    defaultMessage: 'Tuesday'
  },
  wednesday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Wednesday',
    defaultMessage: 'Wednesday'
  },
  thursday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Thursday',
    defaultMessage: 'Thursday'
  },
  friday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Friday',
    defaultMessage: 'Friday'
  },
  saturday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Saturday',
    defaultMessage: 'Saturday'
  },
  sunday: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Sunday',
    defaultMessage: 'Sunday'
  },
  january: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.January',
    defaultMessage: 'January'
  },
  february: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.February',
    defaultMessage: 'February'
  },
  march: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.March',
    defaultMessage: 'March'
  },
  april: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.April',
    defaultMessage: 'April'
  },
  may: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.May',
    defaultMessage: 'May'
  },
  june: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.June',
    defaultMessage: 'June'
  },
  july: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.July',
    defaultMessage: 'July'
  },
  august: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.August',
    defaultMessage: 'August'
  },
  september: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.September',
    defaultMessage: 'September'
  },
  october: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.October',
    defaultMessage: 'October'
  },
  november: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.November',
    defaultMessage: 'November'
  },
  december: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.December',
    defaultMessage: 'December'
  },
  first: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.first',
    defaultMessage: 'First'
  },
  second: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.second',
    defaultMessage: 'Second'
  },
  third: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.third',
    defaultMessage: 'Third'
  },
  fourth: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.Fourth',
    defaultMessage: 'Fourth'
  },
  fifth: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.fifth',
    defaultMessage: 'Fifth'
  },
  pleaseSelectWeek: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectWeek',
    defaultMessage: 'Please select week'
  },
  pleaseSelectDay: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectDay',
    defaultMessage: 'Please select day'
  },
  pleaseSelectMonth: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectMonth',
    defaultMessage: 'Please select month'
  },
  pleaseSelectTime: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectTime',
    defaultMessage: 'Please select time'
  },
  pleaseSelectDateTime: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectDateTime',
    defaultMessage: 'Please select date and time'
  },
  pleaseSelectDays: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectDays',
    defaultMessage: 'Please select day(s)'
  },
  pleaseSelectHours: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectHours',
    defaultMessage: 'Please select hour(s)'
  },
  pleaseSelectMinutes: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectMinutes',
    defaultMessage: 'Please select minutes(s)'
  },
  pleaseSelectDayAndMonth: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectDayAndMonth',
    defaultMessage: 'Please select day and month'
  },
  pleaseSelectScheduleType: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.pleaseSelectScheduleType',
    defaultMessage: 'Please select schedule type'
  },
  required: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.required',
    defaultMessage: '*'
  },
  selectScheduleType: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.selectScheduleType',
    defaultMessage: 'Select schedule type'
  },
  forUsers: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.forUsers',
    defaultMessage: 'For users'
  },
  forUsersDescription: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.forUsersDescription',
    defaultMessage:
      'Will run feature for each user at their local timezone for provided audience and schedule. Any notifications in this feature will be sent to users defined in the trigger audience.'
  },
  scheduledJob: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.scheduledJob',
    defaultMessage: 'Scheduled job'
  },
  scheduledJobDescription: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTrigger.scheduledJobDescription',
    defaultMessage:
      'Will run feature on schedule provided. Tip: Notifications can still be sent at recipients local timezone by configuring send options in the notification step operation'
  },
  audienceTargetingRulePrefixText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.audiencePrefixText',
    defaultMessage: 'This feature will run for all users'
  },
  schedulePrefixText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.schedulePrefixText',
    defaultMessage: 'Scheduled feature to'
  },
  schedulePostfixText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.schedulePostfixText',
    defaultMessage: 'in'
  },
  scheduleTimeText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.scheduleTimeText',
    defaultMessage: 'time'
  },
  run: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.run',
    defaultMessage: 'run'
  },
  on: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.on',
    defaultMessage: 'on'
  },
  forAudience: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.forAudience',
    defaultMessage: 'for the specified audience'
  },
  scheduleType: {
    id: 'SpaceAppBuilderFeaturesPage.operation.scheduledTrigger.scheduleType',
    defaultMessage: 'Schedule Type'
  }
})
